<template>
  <info-header-card :header="header">
    <div slot="body_top_slot">
      <b-row>
        <b-col
          sm="12"
          md="6"
        >
          <template v-for="(row, rowIndex) in leftRows">
            <b-row v-if="row.value" :key="rowIndex">
              <b-col>
                <label class="font-weight-bold">
                  {{ row.label }}
                </label>
              </b-col>

              <b-col>
                <router-link
                  v-if="row.label === 'Customer'"
                  :to="`/customer/${customer.id}`"
                >
                  {{ row.value }}
                </router-link>

                <router-link
                  v-else-if="row.label === 'Project'"
                  :to="`/projects/${project.id}`"
                >
                  {{ row.value }}
                </router-link>

                <router-link
                  v-else-if="row.label === 'Submission'"
                  :to="`/submissions/${submission.id}`"
                >
                  {{ row.value }}
                </router-link>

                <span v-else>{{ row.value }}</span>
              </b-col>
            </b-row>
          </template>
        </b-col>

        <b-col
          sm="12"
          md="6"
        >
          <template v-for="(row, rowIndex) in rightRows">
            <b-row v-if="row.value" :key="rowIndex">
              <b-col>
                <label class="font-weight-bold">
                  {{ row.label }}
                </label>
              </b-col>

              <b-col>
                <span>{{ row.value }}</span>
              </b-col>
            </b-row>
          </template>
        </b-col>
      </b-row>
    </div>
  </info-header-card>
</template>

<script>
import SampleExtensionTableDTO from "@/DTO/ExtensionTables/SampleExtensionTableDTO";
import InfoHeaderCard from "@/components/shared/InfoHeaderCard";

export default {
  name: "SampleCard",
  components: {
    InfoHeaderCard
  },
  props: {
    sample: {
      type: Object,
      default: () => null
    }
  },
  computed: {
    submission() {
      return this.sample.submission_id ? this.sample.getSubmission() : null;
    },
    project() {
      return this.submission ? this.submission.getProject() : null;
    },
    customer() {
      return this.project ? this.project.getCustomer() : null;
    },
    header() {
      return `${this.sample ? this.sample.publicNumber() : "TBD"} | ${
        this.customer ? this.customer.full_name : "TBD"
      }`;
    },
    sampleType () {
      return this.sample.sample_type ? this.sample.sample_type.name : null
    },
    leftRows () {
      const rows = [
        {
          label: "Customer",
          value: this.customer ? this.customer.full_name : "TBD"
        },
        {
          label: "Project",
          value: this.project ? this.project.publicNumber() : "TBD"
        },
        {
          label: "Submission",
          value: this.submission ? this.submission.publicNumber() : "TBD"
        },
        {
          label: "Event Code",
          value: this.submission ? this.submission.event_code : "TBD"
        },
        {
          label: "Receiving #",
          value: this.sample.receiving_id ? this.sample.receiving_id : "TBD"
        },
        {
          label: "Sample Identifier",
          value: this.sample.identifier || "TBD"
        },
        {
          label: "Sample #",
          value: this.sample.number || 'TBD'
        },
      ]

      return rows
    },
    rightRows () {
      const rows = [
        {
          label: "Field",
          value: this.sampleType === 'Soil' ? this.submission.identifier : null
        },
        {
          label: "Grower",
          value: this.submission
            ? this.submission.submission_soil
              ? this.submission.submission_soil.grower
              : this.submission.submission_tissue
                ? this.submission.submission_tissue.grower
                : null
            : null
        },
        {
          label: "Zone",
          value: this.sample.zone
        },
        {
          label: "Irrigated",
          value: this.submission && this.submission.submission_soil ? this.submission.submission_soil.irrigated ? 'Yes' : 'No' : null
        },
        {
          label: "Depth",
          value: (this.sample.depth_start !== null && this.sample.depth_end !== null) && `${this.sample.depth_start} - ${this.sample.depth_end}`
        },
        {
          label: "Package index",
          value: this.sample.index + 1
        },
      ]

      return rows
    }
  },
  methods: {
    setSampleExtension(attribute) {
      return {
        label: SampleExtensionTableDTO.getHoverTextStatic(this.sample, attribute),
        value: this.sample[attribute]
      }
    }
  }
};
</script>
